export const environment = {
  production: false,
  apiUrl: 'https://lbv-maestro-api-prd.azurewebsites.net/api/',
  title: 'HOMOLOGAÇÃO - PIRACANJUBA: Plataforma de Leite Cru'
};

